import React, { useEffect, useState } from "react";
import { APIURL } from "../Config";
import axios from "axios";
import moment from "moment";

function WorkspaceProfileDetails({ lid }) {
  const token = localStorage.getItem("token");

  const [empData, setEmpData] = useState([]);
  const [isLoader, setIsLoader] = useState(false);
  const [transitionHistroy, setTransitionHistroy] = useState([]);

  useEffect(() => {
    getClientDetailsMagic(lid);
    getTransactionSummery(lid);
  }, [lid]);

  const getClientDetailsMagic = (loanId) => {
    setIsLoader(true);

    axios
      .request(`${APIURL}/loanCardDetails/${loanId}`, {
        method: "GET",
        headers: {
          Authentication: token,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        setEmpData(response?.data);
        setIsLoader(false);

        console.log("response::::", response);
      })
      .catch((error) => {
        console.log(error);
        setIsLoader(false);
      });
  };
  const getTransactionSummery = (loanId) => {
    setIsLoader(true);
    axios(`${APIURL}/SucessTxns/` + loanId, {
      method: "GET",
      headers: {
        Authentication: token,
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        let finalArray = [];
        setIsLoader(false);
        console.log("finalArray", finalArray);
        setTransitionHistroy(response.data);
      })

      .catch((error) => {
        console.log("----", error);
        setIsLoader(false);
      });
  };
  return (
    <div className="pt-3">
      <div className="card">
        {isLoader ? (
          <div className="d-flex justify-content-center">
            <div className="spinner-border text-success" role="status">
              <span className="sr-only">Loading...</span>
            </div>
          </div>
        ) : (
          <div className="card-body">
            <div className="mt-3">
              <div className="pt-1" style={{ backgroundColor: "#a6df6d" }}>
                <h5 className="text-center">Profile</h5>
              </div>
              <div className="row ">
                <div
                  className="col-lg-5 col-md-5 col-sm-12 d-flex mt-5"
                  style={{ justifyContent: "center" }}
                >
                  <img
                    src={empData?.clientphotourl}
                    className=""
                    height="250px"
                    width="250px"
                  />
                </div>
                <div
                  className="col-lg-7 col-md-7 col-sm-12 "
                  style={{ fontSize: "14px" }}
                >
                  <div className="row mt-4">
                    <b className="col-4 col-xs-6">Name </b>
                    <p className="col-8 col-xs-6" style={{ fontSize: "16px" }}>
                      {empData?.clientName}
                    </p>
                  </div>
                  <div className="row">
                    <b className="col-4 col-xs-6">Loan Id </b>
                    <p className="col-8 col-xs-6" style={{ fontSize: "16px" }}>
                      {empData?.loanId}
                    </p>
                  </div>{" "}
                  <div className="row">
                    <b className="col-4 col-xs-6">Approval dt </b>
                    <p className="col-8 col-xs-6" style={{ fontSize: "16px" }}>
                      {" "}
                      {/* {borrowerData?.disbursement?.disbdate} */}
                    </p>
                  </div>{" "}
                  <div className="row">
                    <b className="col-4 col-xs-6">Disbursement Dt</b>
                    <p className="col-8 col-xs-6" style={{ fontSize: "16px" }}>
                      {empData?.disdate
                        ? moment(empData.disdate).format("DD-MM-YYYY")
                        : ""}
                    </p>
                  </div>{" "}
                  <div className="row">
                    <b className="col-4 col-xs-6">Mobile</b>
                    <p className="col-8 col-xs-6" style={{ fontSize: "16px" }}>
                      {empData?.mobileNo}
                    </p>
                  </div>{" "}
                  <div className="row">
                    <b className="col-4 col-xs-6">Address</b>
                    <p className="col-8 col-xs-6" style={{ fontSize: "16px" }}>
                      {empData?.clientaddress}
                    </p>
                  </div>{" "}
                  <div className="row">
                    <b className="col-4 col-xs-6">Pan No</b>
                    <p className="col-8 col-xs-6" style={{ fontSize: "16px" }}>
                      {empData?.clientpancard}
                    </p>
                  </div>{" "}
                  <div className="row">
                    <b className="col-4 col-xs-6">Email </b>
                    <p className="col-8 col-xs-6" style={{ fontSize: "16px" }}>
                      {" "}
                      {empData?.clientEmailId}
                    </p>
                  </div>{" "}
                  <div className="row">
                    <b className="col-4 col-xs-6">Limit</b>
                    <p className="col-8 col-xs-6" style={{ fontSize: "16px" }}>
                      {empData?.sanctionAmount}
                    </p>
                  </div>{" "}
                </div>
              </div>
              <div
                className="table-responsive pt-1 mt-3"
                style={{ backgroundColor: "#a6df6d" }}
              >
                <h5 className="text-center">Transaction Summary</h5>
              </div>
              <div className="table-responsive">
                <table className="table table-bordered table-striped">
                  <thead>
                    <tr>
                      <th style={{ textAlign: "center" }}>S No.</th>
                      <th style={{ textAlign: "center" }}>Date Time</th>
                      <th style={{ textAlign: "center" }}>Payee</th>
                      <th style={{ textAlign: "center" }}>Withdrawal</th>
                      <th style={{ textAlign: "center" }}>Payment</th>
                      <th style={{ textAlign: "center" }}>Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    {transitionHistroy.map(
                      (row, index) =>
                        row?.SucessAmount !== 0 && (
                          <>
                            <tr key={index}>
                              <td
                                style={{
                                  textAlign: "center",
                                  whiteSpace: "normal",
                                  fontSize: "14px",
                                  width: "100px",
                                }}
                              >
                                {index + 1}
                              </td>
                              <td
                                style={{
                                  textAlign: "center",
                                  whiteSpace: "normal",
                                  fontSize: "14px",
                                }}
                              >
                                {row?.Date}
                              </td>

                              <td
                                style={{
                                  textAlign: "center",
                                  whiteSpace: "normal",
                                  fontSize: "14px",
                                }}
                              >
                                {row?.Name}
                              </td>
                              <td
                                style={{
                                  textAlign: "center",
                                  whiteSpace: "normal",
                                  fontSize: "14px",
                                }}
                              >
                                {row?.SucessAmount}
                              </td>

                              <td
                                style={{
                                  textAlign: "center",
                                  whiteSpace: "normal",
                                  fontSize: "14px",
                                }}
                              >
                                {row?.tag || 0}
                              </td>

                              <td
                                style={{
                                  textAlign: "center",
                                  whiteSpace: "normal",
                                  fontSize: "14px",
                                }}
                              >
                                {row?.Status}
                              </td>
                            </tr>
                          </>
                        )
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default WorkspaceProfileDetails;
